import api from './client';

// =============================================================================
// Search API — Cross-Pillar Search (Gap 6)
// =============================================================================

export type SearchScope = 'all' | 'command' | 'chronicle' | 'connect';

export interface SearchResult {
  type: 'task' | 'protocol' | 'channel_post' | 'journal';
  id: string;
  title: string;
  snippet: string;
  pillar: 'command' | 'chronicle' | 'connect';
  metadata: Record<string, unknown>;
  score: number;
}

export interface SearchResponse {
  results: SearchResult[];
  total: number;
  query: string;
}

export interface QuickSearchResult {
  type: 'task' | 'protocol' | 'channel_post' | 'journal';
  id: string;
  title: string;
  pillar: 'command' | 'chronicle' | 'connect';
}

export interface QuickSearchResponse {
  results: QuickSearchResult[];
  total: number;
}

export const searchAPI = {
  /**
   * Full cross-pillar search with snippets and metadata
   */
  search(query: string, options?: { scope?: SearchScope; limit?: number; offset?: number }) {
    const params = new URLSearchParams({ q: query });
    if (options?.scope) params.set('scope', options.scope);
    if (options?.limit) params.set('limit', String(options.limit));
    if (options?.offset) params.set('offset', String(options.offset));
    return api.get<{ success: boolean; data: SearchResponse }>(`/search?${params.toString()}`);
  },

  /**
   * Quick search for typeahead (minimal payload, fast response)
   */
  quick(query: string, limit = 5) {
    const params = new URLSearchParams({ q: query, limit: String(limit) });
    return api.get<{ success: boolean; data: QuickSearchResponse }>(`/search/quick?${params.toString()}`);
  },
};
